import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-custom-amount-option', 'CustomAmountOption', component => {
  const container = component.element
  const radio = container.querySelector('.js-c-custom-amount-radio')
  const hiddenInput = container.querySelector('.js-c-custom-amount-value')
  const textInput = container.querySelector('.js-c-custom-amount-input')
  
  // Find all preset radios in the same radio group (sibling amount options)
  const radioGroup = container.closest('.js-c-amount-radio-group')
  const getPresetRadios = () => radioGroup?.querySelectorAll('.c-amount-radio-option input[type="radio"][name]') || []

  // Select the custom option
  const selectCustom = () => {
    // Uncheck all preset radios
    getPresetRadios().forEach(r => r.checked = false)
    // Check our visual radio
    radio.checked = true
    // Enable the hidden input so it submits
    hiddenInput.disabled = false
    // Dispatch change event on the radio for parent components to react
    radio.dispatchEvent(new Event('change', { bubbles: true }))
  }

  // Deselect the custom option (called when a preset is selected)
  const deselectCustom = () => {
    radio.checked = false
    hiddenInput.disabled = true
  }

  // Sync text input value to hidden input
  const syncValue = () => {
    // Parse dollar amount - remove $ and commas
    const cleanValue = textInput?.value?.replace(/[$,]/g, '') || ''
    hiddenInput.value = cleanValue
  }

  // When clicking anywhere in the container (except directly on the input), 
  // select the custom option and focus the input
  const handleContainerClick = (e) => {
    // If clicked directly on the input, just select custom (input already gets focus)
    selectCustom()
    
    if (e.target !== textInput && !textInput?.contains(e.target)) {
      textInput?.focus()
    }
  }

  // When text input value changes, sync to hidden input
  const handleTextInput = () => {
    syncValue()
    // Also ensure custom is selected when typing
    if (!radio.checked) {
      selectCustom()
    }
  }

  // Listen for preset radio changes to deselect custom
  const handlePresetChange = (e) => {
    if (e.target !== radio && e.target.checked) {
      deselectCustom()
    }
  }

  // When text input receives focus (including keyboard tab), select custom option
  const handleTextFocus = () => {
    selectCustom()
  }

  component.useHandler(() => {
    container.addEventListener('click', handleContainerClick)
    textInput?.addEventListener('input', handleTextInput)
    textInput?.addEventListener('focus', handleTextFocus)
    radioGroup?.addEventListener('change', handlePresetChange)
    
    // Initial sync
    syncValue()
    
    return () => {
      container.removeEventListener('click', handleContainerClick)
      textInput?.removeEventListener('input', handleTextInput)
      textInput?.removeEventListener('focus', handleTextFocus)
      radioGroup?.removeEventListener('change', handlePresetChange)
    }
  })
})
